import { Traveler } from './traveler.model';
import { Local } from './local.model';
import { Experiences } from './experiences.model';

export class Bookings {
  id: number;
  ref: string;
  numberOfAdults: string;
  numberOfChildren: string;
  paymentAmount: string;
  startDate: string;
  endDate: string;
  note: string;
  localStatus: string;
  paymentStatus: string;
  bookingStatus: string;
  couponId: string;
  travelerId: string;
  inquiryId: string;
  localId: string;
  languageCode: string;
  createdAt: string;
  updatedAt: string;
  Traveler: Traveler;
  Local: Local;
  Experiences: Experiences[];
  /**
   *
   */
  constructor() {
    this.id = null;
    this.ref = '';
    this.numberOfAdults = '';
    this.numberOfChildren = '';
    this.paymentAmount = '';
    this.startDate = '';
    this.endDate = '';
    this.note = '';
    this.localStatus = '';
    this.paymentStatus = '';
    this.bookingStatus = '';
    this.couponId = '';
    this.travelerId = '';
    this.inquiryId = '';
    this.localId = '';
    this.languageCode = '';
    this.createdAt = '';
    this.updatedAt = '';
  }
}
